function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5DC389",
  fillRule: "evenodd",
  d: "M9.25.545a9.245 9.245 0 0 1 2.074.245.874.874 0 0 1 .468 1.474.877.877 0 0 1-.88.219A7.71 7.71 0 0 0 9.25 2.29 6.948 6.948 0 0 0 4.29 4.35a6.969 6.969 0 0 0-1.5 7.602 7 7 0 0 0 6.461 4.302c3.866 0 7-3.126 7-6.982a.874.874 0 0 1 1.75 0C18 14.093 14.083 18 9.25 18a8.7 8.7 0 0 1-6.125-2.54A8.71 8.71 0 0 1 1.2 5.965 8.75 8.75 0 0 1 9.25.545zm5.62 3.542a.862.862 0 0 1 1.2-.05c.348.31.393.841.102 1.206l-6.073 7.005a.865.865 0 0 1-.625.297.864.864 0 0 1-.616-.253L6.255 9.665a.885.885 0 0 1 0-1.244.866.866 0 0 1 1.232 0l1.987 1.97z"
});

var SvgCheckmarkCircle = function SvgCheckmarkCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckmarkCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark-circle.916b9ded.svg";
export { ForwardRef as ReactComponent };